// extracted by mini-css-extract-plugin
module.exports = {"tipsCon":"index_tipsCon__10bvs","tipsTitleCon":"index_tipsTitleCon__1_f5W","tipsBtnCon":"index_tipsBtnCon__2pE1f"};